// Bank's bank_type constants (follow api Bank::BANK_TYPE val except for 0)
export enum BankTypes {
  Bank = 1,
  PaymentGateway = 2,
  Ewallet = 3,
  PaymentGatewayCrypto = 5,
  Crypto = 6,
}
